import { useEffect, useState } from "react";
import React from "react";
import {
  Col,
  Container,
  Row,
  Input,
  Button,
  Card,
  CardBody,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Label,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import find from "../../../assets/find.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import avatar from "../../../assets/images/personPlaceholder.png";
import check from "../../../assets/images/check.svg";
import moreIcon from "../../../assets/images/more.png";
import { get, del, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useSelector } from "react-redux";
import Placeholder from "../../../assets/images/Placeholder.gif";
const BlogListing = () => {
  document.title = "Blogs Listing | Elevated - Admin Dashboard";
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [blogData, setblogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [userRoles, setUserRoles] = useState([]);
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const itemsPerPage = 6;
  const navigate = useNavigate();
  const location = useLocation();
  const blogId = location.state?.blogData?.data?.id;
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearchTerm(searchTerm), 300);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  const fetchblog = async (page, searchQuery = "") => {
    setLoading(true);
    try {
      console.log(
        appRole != "admin" || appRole != "staff",
        `appRole != "admin" || appRole != "staff"`
      );
      const response = await get(
        `${
          endpoints.blog
        }?limit=${itemsPerPage}&page=${page}&search=${searchQuery}${
          appRole == "gymOwner" || appRole == "gymStaff" ? `&userId=${id}` : ""
        }`
      );
      setblogData(response.data?.data);
      setTotalPages(response.data?.totalPages || 1);
      setItemPerPage(response.data?.data?.length || 0);
      setTotalItems(response.data?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching Blog data:", error);
      // setblogData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchblog(currentPage, debouncedSearchTerm);
  }, [currentPage, debouncedSearchTerm]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) setCurrentPage(page);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSelectChange = async (action, blogId) => {
    switch (action) {
      case "delete":
        await deleteBlog(blogId);
        break;
      case "update":
        const updatedData = {};
        await updateblog(blogId, updatedData);
        break;

      default:
        break;
    }
  };
  const handleBlogDetail = async (blogId) => {
    try {
      const response = await get(`${endpoints.blog}/${blogId}`);
      navigate(`/blog-details`, { state: { blogData: response.data } });
    } catch (error) {
      console.error("Error fetching staff details:", error);
    }
  };
  const deleteBlog = async (blogId) => {
    try {
      await del(`${endpoints.blog}/${blogId}`);
      setblogData((prevData) => prevData.filter((blog) => blog.id !== blogId));
      toast.success("Blog Deleted Successfully", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
      fetchblog(currentPage);
    } catch (error) {
      console.error("Error deleting Blog:", error);
    }
  };

  const updateblog = async (blogId, updatedData) => {
    try {
      await put(`${endpoints.blog}/${blogId}`, updatedData);
      fetchblog(currentPage, searchTerm);
    } catch (error) {
      console.error("Error updating blog:", error);
    }
  };
  const updateBlogStatus = async (blogId, status) => {
    try {
      const resp = await put(`${endpoints.blog}/${blogId}`, {
        status: status == false ? "publish" : "draft",
      });
      if (resp?.data?.success) {
        fetchblog(currentPage, searchTerm);
      }
    } catch (error) {
      console.error("Error updating blog:", error);
    }
  };

  const handleEditblog = (blogId) => {
    navigate(`/add-blog?blogId=${blogId}&isUpdate=true`);
  };

  const toggleDropdown = (blogId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [blogId]: !prevState[blogId],
    }));
  };

  const renderContent = (blog) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(
      blog?.content?.htmlContent || "",
      "text/html"
    );
    const textContent = doc.body.textContent || "";

    const words = textContent.split(" ") || [];

    return words.slice(0, 5).join(" ") + (words?.length > 5 ? "..." : "");
  };
  const { appRole, id, userPermissions } = useSelector((state) => {
    return state.auth.currentUser;
  });
  return (
    <div className="">
      <Container fluid>
        <Row>
          <Col>
            <Card className="rounded-4">
              <CardBody>
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3">
                  {/* Title and Search Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    {/* Title */}
                    <span className="font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0">
                      Blogs/News
                    </span>

                    {/* Search Bar */}
                    <div
                      className="w-100 w-sm-auto bg-light ff-sora d-flex justify-content-between align-items-center"
                      style={{
                        borderRadius: "12px",
                        height: "48px",
                        maxWidth: "400px",
                      }} // Added maxWidth
                    >
                      {/* Search Icon */}
                      <img
                        src={find}
                        alt="Search"
                        className="light-black"
                        style={{
                          height: "24px",
                          width: "24px",
                          marginLeft: "10px",
                        }}
                      />

                      {/* Search Input */}
                      <Input
                        type="text"
                        name="search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="ff-sora light-black font-size-14 fw-normal w-100"
                        style={{ background: "transparent", border: "none" }}
                        placeholder="Search"
                      />
                    </div>
                  </div>

                  {/* Add New Button Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-end align-items-center gap-2 w-100 mt-2 mt-sm-0">
                    {userPermissions?.blog?.["Create Blog"] && (
                      <Link to="/add-blog" className="w-auto w-sm-100">
                        <Button
                          className="rounded-pill w-auto w-sm-100" // Full width on small screens, auto width on larger screens
                          style={{ minWidth: "120px" }} // Compact width on larger screens
                        >
                          Add New
                        </Button>
                      </Link>
                    )}
                  </div>
                </div>

                <div
                  className="table-responsive rounded-4 hide-scrollbar"
                  style={{
                    height: blogData?.length > 0 ? "500px" : "auto",
                  }}
                >
                  <Table
                    hover
                    className="table-borderless table-centered table-nowrap"
                  >
                    <thead>
                      <tr>
                        <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                          Id
                        </th>
                        <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                          Blog
                        </th>
                        <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                          Content
                        </th>
                        <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                          Added on
                        </th>
                        <th className="font-size-14 mb-1 fw-bold ff-sora secondary-black">
                          Status
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={8} className="text-center">
                            <div className="d-flex justify-content-center align-items-center">
                              <div
                                className="spinner-border"
                                style={{
                                  width: "3rem",
                                  height: "3rem",
                                  color: "#3BABA6",
                                }}
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : blogData?.length === 0 ? (
                        <></>
                      ) : (
                        blogData?.map((blog, index) => (
                          <tr key={index}>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <img
                                  src={
                                    blog?.File == null
                                      ? avatar
                                      : `${process.env.REACT_APP_IMG_URL}${blog?.File}`
                                  }
                                  className="avatar-xs rounded-2 font-size-14 ff-sora fw-normal object-fit-cover me-2"
                                  alt={`${blog?.firstName}'s avatar`}
                                />
                                <div>
                                  <h6
                                    className="font-size-14 mb-1 fw-normal ff-sora secondary-black"
                                    onClick={() => handleBlogDetail(blog.id)}
                                  >
                                    {blog?.title}
                                  </h6>
                                </div>
                              </div>
                            </td>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {renderContent(blog)}
                            </td>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              {blog.createdAt
                                ? new Date(blog.createdAt).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                              <FormGroup switch>
                                {(appRole == "admin" || appRole == "staff") && (
                                  <Input
                                    type="switch"
                                    checked={
                                      blog.status == "draft" ? false : true
                                    }
                                    onClick={() => {
                                      updateBlogStatus(
                                        blog.id,
                                        blog.status == "draft" ? false : true
                                      );
                                    }}
                                  />
                                )}
                                <Label check className="text-capitalize">
                                  {blog.status}
                                </Label>
                              </FormGroup>
                            </td>
                            <td>
                              <Dropdown
                                isOpen={dropdownOpen[blog.id]}
                                toggle={() => toggleDropdown(blog.id)}
                                direction="down"
                              >
                                <DropdownToggle
                                  tag="button"
                                  className="btn btn-link p-0"
                                >
                                  <img src={moreIcon} alt="More options" />
                                </DropdownToggle>
                                <DropdownMenu end>
                                  {userPermissions?.blog?.["Update Blog"] && (
                                    <DropdownItem
                                      className="fw-normal ff-sora secondary-black font-size-14"
                                      onClick={() => handleEditblog(blog.id)}
                                    >
                                      Edit Blog
                                    </DropdownItem>
                                  )}
                                  {userPermissions?.blog?.["Delete Blog"] && (
                                    <DropdownItem
                                      className="fw-normal ff-sora secondary-black font-size-14"
                                      onClick={() =>
                                        handleSelectChange("delete", blog.id)
                                      }
                                    >
                                      Delete Blog
                                    </DropdownItem>
                                  )}
                                  {userPermissions?.blog?.["View Blog"] && (
                                    <DropdownItem
                                      className="fw-normal ff-sora secondary-black font-size-14"
                                      onClick={() => handleBlogDetail(blog.id)}
                                    >
                                      Blog Detail
                                    </DropdownItem>
                                  )}
                                </DropdownMenu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  {!loading && blogData?.length === 0 && (
                    <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                      <img
                        src={Placeholder}
                        alt="No record placeholder"
                        className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                      />
                      <p className="mt-3 ff-sora font-size-16 fw-normal">
                        No Record Found!
                      </p>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>

            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "40px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
                backgroundColor: "#f5f5f5",
              }}
            >
              <div>
                <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                  {`Showing ${Math.min(
                    (currentPage - 1) * itemsPerPage + itemPerPage
                  )} of ${totalItems}`}
                </span>
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Button>
                {[...Array(totalPages).keys()]
                  .slice(
                    Math.max(0, currentPage - 2),
                    Math.min(totalPages, currentPage + 1)
                  )
                  .map((page, index) => (
                    <Button
                      key={index + 1}
                      onClick={() => handlePageChange(page + 1)}
                      style={{
                        width: "40px",
                        height: "40px",
                        color: currentPage === page + 1 ? "white" : "#1f1f1f",
                        background:
                          currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "80px",
                        border: 0,
                      }}
                      className={currentPage === page + 1 ? "active" : ""}
                    >
                      {page + 1}
                    </Button>
                  ))}
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    width: "40px",
                    height: "40px",
                    color: "#1f1f1f",
                    borderWidth: "1px",
                    borderColor:
                      currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                    background: "#f5f5f5",
                    borderRadius: "80px",
                  }}
                >
                  &gt;
                </Button>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BlogListing;
